import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ConnectFormDirective } from './connect-form.directive';
import { ClickOutsideDirective } from './click-outside.directive';
import { DialogPanelDirective } from './dialog-panel.directive';
import { InfoPopupComponent } from './info-popup/info-popup.component';



@NgModule({
  declarations: [SafeHtmlPipe, ConnectFormDirective, ClickOutsideDirective, DialogPanelDirective, InfoPopupComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MatDialogModule,
    AngularSvgIconModule
  ],
  exports:[
    TranslateModule,
    SafeHtmlPipe,
    ConnectFormDirective,
    ClickOutsideDirective,
    DialogPanelDirective
  ]
})
export class SharedModule { }
